// extracted by mini-css-extract-plugin
export default {"funding":"underwritingFormSections_funding__BcmSx","dropdown":"underwritingFormSections_dropdown__9cW4z"};